import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
// Opposition + useOppositions live in shared; re-exported here so the
// existing importers of this hook module keep working.
export { useOppositions } from '@/shared/hooks/useOppositions';
export function useSubjects(oppositionId) {
    return useQuery({
        queryKey: ['subjects', oppositionId ?? 'all'],
        queryFn: () => {
            const qs = oppositionId ? `?opposition_id=${encodeURIComponent(oppositionId)}` : '';
            return apiClient(`/subjects${qs}`);
        },
        staleTime: 1000 * 60 * 5,
    });
}
export function useCreateSubject() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient('/subjects', { method: 'POST', body: JSON.stringify(dto) }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['subjects'] }),
    });
}
export function useUpdateSubject() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, ...rest }) => apiClient(`/subjects/${id}`, { method: 'PATCH', body: JSON.stringify(rest) }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['subjects'] }),
    });
}
export function useDeleteSubject() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => apiClient(`/subjects/${id}`, { method: 'DELETE' }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['subjects'] }),
    });
}
//# sourceMappingURL=useSubjects.js.map